module.exports = __webpack_public_path__ + "img/tractor-photo-05.d081867c.jpeg";